// dependencies
import { useEffect, useState } from "react"
import { Link, useMatch, useResolvedPath } from "react-router-dom"

// components
import { useAuth } from "../../contexts/AuthContext"

// style
import styles from "./css/Navbar.module.css"


const Navbar = () => {
    // get current user from auth context
    const { currentUser } = useAuth();
    const [mobileMenuIsOpen, setMobileMenuIsOpen] = useState(false);
    const [isClosing, setIsClosing] = useState(false);
    const [isOpening, setIsOpening] = useState(false);


    // toggle mobile menu
    const toggleMenu = () => {
        if (mobileMenuIsOpen) {
            setIsClosing(true);
            setTimeout(() => {
                setMobileMenuIsOpen(false);
                setIsClosing(false);
            }, 300);
        } else {
            setMobileMenuIsOpen(true);
            // Delay the animation class just a bit to allow mount
            setTimeout(() => setIsOpening(true), 10);
        }
    };

    useEffect(() => {
        if (!mobileMenuIsOpen) {
            setIsOpening(false);
        }
    }, [mobileMenuIsOpen]);



    return (
        <div className={styles.navbarContainer}>
            <div className={styles.navbar}>
                <Link className={styles.navLogo} to="/CodeNameHaar">
                    CodeNameHaar
                </Link>

                <button className={styles.hamburger} onClick={toggleMenu}>
                    <span className={styles.bar}></span>
                    <span className={styles.bar}></span>
                    <span className={styles.bar}></span>
                </button>

                <ul className={styles.navLinks}>
                    <CustomLink to="/projects">Projects</CustomLink>
                    <CustomLink to="/contact">Contact</CustomLink>

                    {currentUser ? (
                        <>
                            <CustomLink to="/profile">Profile</CustomLink>
                        </>
                    ) : (
                        <>
                            <CustomLink to="/login">Login</CustomLink>
                        </>
                    )}
                </ul>
            </div>

            {/* overlay menu for mobile */}
            {(mobileMenuIsOpen || isClosing) && (
                <div className={`${styles.mobileMenu} ${ isClosing ? styles.menuClose : isOpening ? styles.menuOpen : "" }`}>
                    <CustomLink to="/" onClick={toggleMenu}>Home</CustomLink>
                    <CustomLink to="/projects" onClick={toggleMenu}>Projects</CustomLink>
                    <CustomLink to="/contact" onClick={toggleMenu}>Contact</CustomLink>
                    {currentUser ? (
                        <>
                            <CustomLink to="/profile" onClick={toggleMenu}>Profile</CustomLink>
                        </>
                    ) : (
                        <CustomLink to="/login" onClick={toggleMenu}>Login</CustomLink>
                    )}
                </div>
            )}
        </div>
    )
}

// == Custom Link component for Navbar ==
let CustomLink = ({ to, children, ...props }) => {
    const resolvedPath = useResolvedPath(to)
    const isActive = useMatch({ path: resolvedPath.pathname, end: true })

    return (
        <li className={isActive ? styles.active : ""}>
            <Link to={to} {...props} className={styles.navLink}>
                {children}
            </Link>
        </li>
    )
}

export default Navbar
